import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export const editReport = async (id, report) => {
  const endpoint = `${apiEndpoints.report}/${id}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.put(URL, report, { withCredentials: true }))
}
